
export default {
  name: 'SalesTaxCalculator',
  data () {
    return {
      data: '',
      form: this.$vform({
        tax: 'exclusive',
        amount: null,
        rate: null
      })
    }
  },
  methods: {
    onSalesTaxCalculator() {
        this.form.post(`/tool/sales-tax-calculator`, { progress: false }).then(res => {
          this.data = Object.values(res.data);
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
		this.form.tax    = 'exclusive';
		this.form.amount = 100;
		this.form.rate   = 6.5;
    },
    onReset(){
        this.form.reset();
        this.data = '';
    },
    copyToClipboard() {
      document.getElementById("text").select();
      document.execCommand('copy');
    }
  }
}
